// client/src/App.js

import React from "react";
import logo from "../logo.svg";
import "../App.css";
import CommonContext from '../commonContext';
import { postCall } from "../utils/requests";
import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Select,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Tfoot,
  Th,
  Thead,
  Tr,
  HStack,
  useToast,
  Badge,
  Image,
  Divider,
  Grid,
  GridItem,
  VStack
} from '@chakra-ui/react';

function SettingsPage() {
  const [livestream, setLivestream] = React.useState("");
  const [livestreamActive, setLivestreamActive] = React.useState(false);
  const [firstMessageActive, setFirstMessageActive] = React.useState(false);
  const [firstMessage, setFirstMessage] = React.useState("");
  const [askReview, setAskReview] = React.useState(false);


  const toast = useToast();

  const commonContext = React.useContext(CommonContext);

  const fetchSettings = async () => {

    let resp = await postCall("/fetchSettings", {});


    if (resp !== undefined && resp !== null && resp.status === "success") {
      for (let i = 0; i < resp.data.length; i++) {
        let setting = resp.data[i];
        if (setting.param === "livestream") {
          if (setting.value !== "" && setting.value !== null && setting.value !== undefined) {
            setLivestream(setting.value ?? "");
            setLivestreamActive(true);
          } else {
            setLivestream("");
            setLivestreamActive(false);
          }
        }
        if (setting.param === "msg_active") {
          if (setting.value !== "" && setting.value !== null && setting.value !== undefined && setting.value === "1") {
            setFirstMessageActive(true);
          } else {
            setFirstMessageActive(false);
          }
        }
        if (setting.param === "msg_text") {
          setFirstMessage(setting.value ?? "");
        }
        if (setting.param === "review_active") {
          if (setting.value !== "" && setting.value !== null && setting.value !== undefined && setting.value === "1") {
            setAskReview(true);
          } else {
            setAskReview(false);
          }
        }
      }

    }

  }


  React.useEffect(() => {
    fetchSettings();

    commonContext.setCurrentPath("Impostazioni")
    commonContext.setCurrentPage("settings")

  }, []);


  const stopStreaming = async () => {
    let resp = await postCall("/stopLiveStream", {});
    if (resp !== undefined && resp !== null && resp.status === "success") {
      fetchSettings();
      toast({
        title: "Perfetto",
        description: "Streaming fermato",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
    } else {
      toast({
        title: "Errore",
        description: "Si è verificato un errore: " + resp.error,
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
    }
  }


  const startStreaming = async () => {
    let resp = await postCall("/setLiveStream", { livestream: livestream });
    if (resp !== undefined && resp !== null && resp.status === "success") {
      fetchSettings();
      toast({
        title: "Perfetto",
        description: "Streaming avviato",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
    } else {
      toast({
        title: "Errore",
        description: "Si è verificato un errore: " + resp.error,
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
    }
  }


  const stopFirstMessage = async () => {

    if (firstMessage === "" || firstMessage === null || firstMessage === undefined) {
      toast({
        title: "Errore",
        description: "Inserisci un messaggio",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    let resp = await postCall("/stopFirstMessage", {});
    if (resp !== undefined && resp !== null && resp.status === "success") {
      fetchSettings();
      toast({
        title: "Perfetto",
        description: "Messaggio disattivato",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
    } else {
      toast({
        title: "Errore",
        description: "Si è verificato un errore: " + resp.error,
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
    }
  }


  const startFirstMessage = async () => {
    let resp = await postCall("/startFirstMessage", { msg_text: firstMessage });
    if (resp !== undefined && resp !== null && resp.status === "success") {
      fetchSettings();
      toast({
        title: "Perfetto",
        description: "Messaggio attivato",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
    } else {
      toast({
        title: "Errore",
        description: "Si è verificato un errore: " + resp.error,
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
    }
  }



  return (
    <div>
      {/*  <h1>Settings</h1> */}
      <Flex justifyContent="center">
        {/* START - live streaming */}

        <Flex p="30px" h="500px" mt="2%" ml="2%" mr="2%" w="45%" bg="blue.200" borderRadius="lg" direction={"column"} >
          <VStack direction={"column"} >
            <Flex justifyContent="center">
              <Text fontSize="2xl" justifyContent="center" textAlign="center" className='adlam-font' fontWeight="bold">
                Live Streaming
              </Text>

            </Flex>

            <Flex justifyContent="center">
              <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' fontWeight="normal">
                Inserisci un link per avviare lo streaming in diretta
              </Text>
            </Flex>

            {!livestreamActive &&
              <Flex justifyContent="center">
                <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' color="red" fontWeight="normal">
                  NON ATTIVO
                </Text>
              </Flex>}

            {livestreamActive &&
              <Flex justifyContent="center">
                <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' color="green" fontWeight="normal">
                  ATTIVO
                </Text>
              </Flex>}

            <Center>
              <Divider mt="40px" w="90%"></Divider>
            </Center>
          </VStack>
          <VStack direction={"column"} h="60%" >
            <FormLabel mt="25px">Link Streaming</FormLabel>
            <Input
              bg="white"
              type="text"
              value={livestream}
              onChange={(event) => setLivestream(event.target.value)}
            />
          </VStack>
          <VStack pt="20px" pb="20px" direction={"column"} h="20%" >
            {livestreamActive &&
              <Button
                position="relative"
                bottom="0"
                alignSelf={"center"}
                type="submit"
                colorScheme="red"
                onClick={stopStreaming}>Ferma streaming</Button>
            }


            {!livestreamActive &&
              <Button
                position="relative"
                bottom="0"
                alignSelf={"center"}
                // Adjust padding to match Box padding
                type="submit"
                colorScheme="green"
                onClick={startStreaming}>Avvia streaming</Button>
            }
          </VStack>
        </Flex>
        {/* STOP - message at opened app */}


        {/* START - message at opened app */}
        <Flex p="30px" mt="2%" ml="2%" mr="2%" w="45%" bg="blue.200" borderRadius="lg" direction={"column"} >
          <VStack direction={"column"} >
            <Flex justifyContent="center">
              <Text fontSize="2xl" justifyContent="center" textAlign="center" className='adlam-font' fontWeight="bold">
                Messaggio all'avvio
              </Text>
            </Flex>

            <Flex justifyContent="center">
              <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' fontWeight="normal">
                Inserisci il messaggio che gli utenti visualizzano all'avvio dell'app (una sola volta)
              </Text>
            </Flex>

            {!firstMessageActive &&
              <Flex justifyContent="center">
                <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' color="red" fontWeight="normal">
                  NON ATTIVO
                </Text>
              </Flex>}

            {firstMessageActive &&
              <Flex justifyContent="center">
                <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' color="green" fontWeight="normal">
                  ATTIVO
                </Text>
              </Flex>}

            <Center>
              <Divider mt="40px" w="90%"></Divider>
            </Center>
          </VStack>
          <VStack direction={"column"} h="60%" >
            <FormLabel mt="25px">Messaggio</FormLabel>
            <Textarea
              bg="white"
              type="text"
              resize={"none"}
              value={firstMessage}
              onChange={(event) => setFirstMessage(event.target.value)}
            />
          </VStack>
          <VStack pt="20px" pb="20px" direction={"column"} h="20%" >
            {firstMessageActive &&
              <Button
                position="relative"
                bottom="0"
                type="submit" colorScheme="red" onClick={stopFirstMessage}>Disattiva messaggio</Button>
            }

            {!firstMessageActive &&
              <Button
                position="relative"
                bottom="0"
                type="submit"
                colorScheme="green"
                onClick={startFirstMessage}>Attiva messaggio</Button>
            }
          </VStack>
        </Flex>
        {/* END - message at opened app */}


      </Flex>

      <Flex justifyContent="center">
        {/* START - ask for review */}

        {/* <Flex p="30px" mt="2%" ml="2%" mr="2%" w="45%" bg="blue.200" borderRadius="lg" direction={"column"} >
          <VStack direction={"column"} >
            <Flex justifyContent="center">
              <Text fontSize="2xl" justifyContent="center" textAlign="center" className='adlam-font' fontWeight="bold">
                Chiedi recensione o feedback
              </Text>

            </Flex>

            <Flex justifyContent="center">
              <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' fontWeight="normal">
                All'avvio dell'applicazione, per una volta, gli utenti sono invitati a lasciare una recensione o inviare un feedback
              </Text>
            </Flex>

            {!livestreamActive &&
              <Flex justifyContent="center">
                <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' color="red" fontWeight="normal">
                  NON ATTIVO
                </Text>
              </Flex>}

            {livestreamActive &&
              <Flex justifyContent="center">
                <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' color="green" fontWeight="normal">
                  ATTIVO
                </Text>
              </Flex>}

            <Center>
              <Divider mt="40px" w="90%"></Divider>
            </Center>
          </VStack>
          <VStack direction={"column"} h="60%" >
            <FormLabel mt="25px">Link Streaming</FormLabel>
            <Input
              bg="white"
              type="text"
              value={livestream}
              onChange={(event) => setLivestream(event.target.value)}
            />
          </VStack>
          <VStack pt="20px" pb="20px" direction={"column"} h="20%" >
            {livestreamActive &&
              <Button
                position="relative"
                bottom="0"
                alignSelf={"center"}
                type="submit"
                colorScheme="red"
                onClick={stopStreaming}>Ferma streaming</Button>
            }


            {!livestreamActive &&
              <Button
                position="relative"
                bottom="0"
                alignSelf={"center"}
                // Adjust padding to match Box padding
                type="submit"
                colorScheme="green"
                onClick={startStreaming}>Avvia streaming</Button>
            }
          </VStack>
        </Flex> */}
        {/* END - ask for review */}


        {/* START - message at opened app */}
        <Box ml="2%" mr="2%" w="45%">

        </Box>
        {/* <Flex p="30px" h="500px" mt="2%" ml="5%" mr="5%" w="45%" bg="blue.200" borderRadius="lg" direction={"column"} >
          <VStack direction={"column"} >
            <Flex justifyContent="center">
              <Text fontSize="2xl" justifyContent="center" textAlign="center" className='adlam-font' fontWeight="bold">
                Messaggio all'avvio
              </Text>
            </Flex>

            <Flex justifyContent="center">
              <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' fontWeight="normal">
                Inserisci il messaggio che gli utenti visualizzano all'avvio dell'app (una sola volta)
              </Text>
            </Flex>

            {!firstMessageActive &&
              <Flex justifyContent="center">
                <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' color="red" fontWeight="normal">
                  NON ATTIVO
                </Text>
              </Flex>}

            {firstMessageActive &&
              <Flex justifyContent="center">
                <Text fontSize="xl" justifyContent="center" textAlign="center" className='adlam-font' color="green" fontWeight="normal">
                  ATTIVO
                </Text>
              </Flex>}

            <Center>
              <Divider mt="40px" w="90%"></Divider>
            </Center>
          </VStack>
          <VStack direction={"column"} h="60%" >
            <FormLabel mt="25px">Messaggio</FormLabel>
            <Textarea
              bg="white"
              type="text"
              resize={"none"}
              value={firstMessage}
              onChange={(event) => setFirstMessage(event.target.value)}
            />
          </VStack>
          <VStack pt="20px" pb="20px" direction={"column"} h="20%" >
            {firstMessageActive &&
              <Button
                position="relative"
                bottom="0"
                type="submit" colorScheme="red" onClick={stopFirstMessage}>Disattiva messaggio</Button>
            }

            {!firstMessageActive &&
              <Button
                position="relative"
                bottom="0"
                type="submit"
                colorScheme="green"
                onClick={startFirstMessage}>Attiva messaggio</Button>
            }
          </VStack>
        </Flex> */}
        {/* END - message at opened app */}


      </Flex>

    </div>
  );
}

export default SettingsPage;